import { call, put, takeEvery } from 'redux-saga/effects'

import {
    GET_AVAILABLEDEPARTMENTS_REQUESTED,
    GET_WORKSESSION_REQUESTED,
} from '../actions/actionTypes'
import {
    getAvailableCashboxesSuccess,
    selectionWorkSessionSuccess,
    returnFailed
} from '../actions/dashboardAction'
import { messages } from '../../helpers/messages'
import { cashBoxService } from '../../services/cashbox-service'
import { authActions } from '../../actions/auth'
import { AVAILABLE_DEPARTMENTS } from '../../constants/localStorageConstants'

const getDepartments = async () =>
    await cashBoxService.getAvailableCashBoxes()
        .then(({ data: { cashboxes } }) => cashboxes)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages["0"]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                throw commonError
            }
        })

const getWorkSession = (payload) => authActions.workSession(payload)
    .catch(() => "Ошибка неизвестного характера. Обратитесь к администратору.")

function* fetchGetDepartments() {
    try {
        const cashboxes = yield call(() => getDepartments())
        localStorage.setItem(AVAILABLE_DEPARTMENTS, JSON.stringify(cashboxes.map(({ id }) => id)));

        yield put(getAvailableCashboxesSuccess(cashboxes))
    } catch (error) {
        yield put(returnFailed(error))
    }
}

function* fetchGetWorkSession({ payload }) {
    try {
        const workSession = yield call(() => getWorkSession(payload))
        yield put(selectionWorkSessionSuccess(workSession))
    } catch (error) {
        yield put(returnFailed(error))
    }
}

function* getAvailableDepartmentsSaga() {
    yield takeEvery(GET_AVAILABLEDEPARTMENTS_REQUESTED, fetchGetDepartments)
}

function* getWorkSessionSaga() {
    yield takeEvery(GET_WORKSESSION_REQUESTED, fetchGetWorkSession)
}

export {
    getAvailableDepartmentsSaga,
    getWorkSessionSaga
}